import { useMutation } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { login as loginApi, logout as logoutApi } from '../api/auth'
import { useAuthStore } from '../store/authStore'
import { STORAGE_KEYS } from '../utils/constants'

export const useAuth = () => {
  const { setAuth, clearAuth, isAuthenticated, user } = useAuthStore()

  const loginMutation = useMutation({
    mutationFn: ({ username, password }) => loginApi(username, password),
    onSuccess: (data) => {
      // La respuesta tiene estructura: { code, payload, message }
      const { token } = data.payload
      const user = data.payload

      // Guardar en store
      setAuth(token, user)

      // Guardar token en localStorage para interceptor de Axios
      localStorage.setItem(STORAGE_KEYS.AUTH_TOKEN, token)
      localStorage.setItem(STORAGE_KEYS.USER_DATA, JSON.stringify(user))

      toast.success('Sesión iniciada correctamente')
    },
    onError: (error) => {
      console.error('Error en login:', error)
      toast.error('Credenciales incorrectas')
    },
  })

  const logoutMutation = useMutation({
    mutationFn: logoutApi,
    onSuccess: () => {
      clearAuth()
      localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN)
      localStorage.removeItem(STORAGE_KEYS.USER_DATA)
      toast.success('Sesión cerrada')
    },
  })

  return {
    login: loginMutation.mutate,
    logout: logoutMutation.mutate,
    isLoggingIn: loginMutation.isPending,
    isAuthenticated,
    user,
  }
}
